import React from "react";
import { useHistory } from "react-router-dom";
import Slider from "react-slick";
import AnnouncementCard from "./AnnouncementCard";

export default function Announcement({ announcements }) {
  const history = useHistory();

  const cardPerPage =
    announcements.length === 1
      ? 1
      : announcements.length === 2
      ? 2
      : announcements.length === 3
      ? 3
      : 4;

  const settings = {
    infinite: true,
    slidesToShow: cardPerPage,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 2000,
    cssEase: "linear",
  };

  const handleClick = (item) => {
    history.push(`announcement/${item.id}`);
  };

  return (
    <div className="py-10">
      <div className="flex flex-col items-center">
        <div className="text-2xl font-bold">News & Announcements</div>
        <div className="text-xl">Get all the latest News & Announcements</div>
      </div>
      <div className="mt-10">
        <Slider {...settings}>
          {announcements.map((item, index) => {
            return (
              <AnnouncementCard
                key={index}
                item={item}
                handleClick={() => handleClick(item)}
              />
            );
          })}
        </Slider>
      </div>
    </div>
  );
}
